var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51404_1955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.719 477.031L477.656 400.156L346.719 323.281V477.031Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 0C179.063 0 0 179.063 0 400C0 620.938 179.063 800 400 800C620.938 800 800 620.938 800 400C800 179.063 620.938 0 400 0ZM600 471.562C600 540.469 531.094 540.469 531.094 540.469H268.906C200 540.469 200 471.562 200 471.562V328.594C200 259.687 268.906 259.688 268.906 259.688H531.094C600 259.688 600 328.594 600 328.594V471.562Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51404_1955"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeSocial);
export default __webpack_public_path__ + "static/media/youtube-social.ed5e76f996156706fef6eb0ab5aba35e.svg";
export { ForwardRef as ReactComponent };